import * as React from 'react';
import { Fragment, useState } from 'react';
import {
    Button,
    Confirm,
    useUpdateMany,
    useRefresh,
    useNotify,
    useUnselectAll,
} from 'react-admin';

const ActivityRegistrationReviewButton = ({ selectedIds }) => {
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [status, setStatus] = useState('active');
    const [updateMany, { loading }] = useUpdateMany(
        'activity-registrations/validate',
        selectedIds,
        { status: status },
        {
            onSuccess: () => {
                refresh();
                notify('Updated');
                unselectAll('activity-registrations');
            },
            onFailure: (error) => {
                refresh();
                notify(`Error: ${error.message}`, 'warning')
            },
        }
    );
    const handleClick = (s) => {
        setStatus(s);
        setOpen(true);
    }
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        updateMany();
        setOpen(false);
    };

    return (
        <Fragment>
            <Button label="Validate" onClick={() => handleClick('active')} />
            <Button label="Refuse" onClick={() => handleClick('refused')} />
            <Confirm
                isOpen={open}
                loading={loading}
                title="Update The Status Of Activity Registrations"
                content="Are you sure you want to validate / refuse the selected items?"
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
}

export default ActivityRegistrationReviewButton;